import React, { createContext, useState } from "react";
import { Form } from "antd";

export const handleForm = createContext();
export function HandleFormContext({ children }) {
  const [form] = Form.useForm();
  const [showReject, setshowReject] = useState(false);

  const storeFormProvider = {
    form,
    showReject,
    setshowReject,
  };
  return (
    <handleForm.Provider value={storeFormProvider}>
      {children}
    </handleForm.Provider>
  );
}
